import React, {useEffect, useState} from "react";
import {mayBe} from "./utils";
import {DocRow, DocTitle} from "../../components";
import {RefregaResponse} from "../../types/refprega";
import {DocumentsBatch, RefpadoDocument} from "../../types";
import {QRFooter} from "../qr_footer/QRFooter";
import {selectedDocument} from "./index";
import {AvailableDocuments} from "./AvailableDocuments";


export const RefregaDoc: React.FC<{ documents: DocumentsBatch , withVersions?: boolean }> = ({
                                                                                                 documents,
                                                                                                 withVersions = true
                                                                                             }) => {

    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<RefregaResponse>(
            selectedDocument.document.document as RefregaResponse
    )

    useEffect(() => {
        setDocument(selectedDocument.document.document as RefregaResponse);
    }, [selectedDocument.document.version]);


    const isRegByAddressType = doc.regMan === '1' && doc.personInfo.regType !== '4';
    const isNoRegByAddressType = doc.regMan !== '1' && doc.personInfo.regType === '4';

    console.log('regMan: ', doc.regMan, 'regType: ', doc.personInfo.regType)

    const title =
            isRegByAddressType
                    ? `Справка о регистрации по адресу № ${mayBe(doc.refNumber) || 'б/н'}`
                    : isNoRegByAddressType
                            ? `Справка об отсутствии зарегистрированных граждан № ${mayBe(doc.refNumber) || 'б/н'}`
                            : `Справка № ${mayBe(doc.refNumber) || 'б/н'}`

    const subTitle = 'Выдана заявителю:';

    const getDocument = (document: RefpadoDocument) => {
        const {documentType, serial = '', number = '', issuedBy = '', issuedDate = ''} = document;
        if (!serial && !number && !issuedBy && !issuedDate) {
            return documentType;
        }
        return `${documentType} ${serial} №${number}, выдан ${issuedBy} от ${issuedDate}`;
    };

    return (
            <>
                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={title} subtitle={subTitle} uid={doc.blockchainUid}/>
                </div>

                <div className="col-span-12 md:col-span-8">
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Фамилия" bold value={mayBe(doc.personInfo.lastName)}/>
                        <DocRow title="Имя" bold value={mayBe(doc.personInfo.firstName)}/>
                        <DocRow title="Отчество" bold value={mayBe(doc.personInfo.midName)}/>
                        <DocRow title="Дата рождения" bold value={mayBe(doc.personInfo.birthdate) || '-'}/>
                        <DocRow
                                title="Документ удостоверяющий личность"
                                bold
                                value={getDocument(doc.personInfo.document)}
                        />
                    </div>

                    <DocTitle subtitle={
                        isRegByAddressType
                                ? 'Заявитель/гражданин зарегистрирован по месту жительства/пребывания.'
                                : 'Сведения о зарегистрированных в жилом помещении отсутствуют.'}
                              title={''}/>

                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Адрес регистрации" bold value={mayBe(doc.personInfo.regAddress)}/>
                    </div>

                    <QRFooter blockchainUid={doc.blockchainUid}
                              refDate={doc.refDate}
                              mfcInfoName={doc.mfcInfo.name}
                              mfcUserName={doc.mfcUser.name}
                    />
                </div>
                {
                        withVersions && documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-last">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'md:-mt-12 mb-5'}
                            />
                        </div>
                }
            </>
    );
};
